import type { IconDecorationProtocol } from '@lighthouse/core'
import React from 'react'
import styled from 'styled-components'

import { AudioStatusIcon } from './AudioStatusIcon'

interface PlayOnlyButtonProps {
    playing: boolean
    error: boolean
    disabled?: boolean
    icon?: IconDecorationProtocol
    iconColor?: string
    onGetFullUrl?: (url: string) => string
    onToggle: () => void
}

const Root = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: var(--color-gray-100, #f2f4f7);
    color: var(--color-gray-800, #1d2939);
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`

export const PlayOnlyButton: React.FC<PlayOnlyButtonProps> = ({
    playing,
    error,
    disabled,
    icon,
    iconColor,
    onGetFullUrl,
    onToggle
}) => {
    return (
        <Root type="button" disabled={disabled || error} onClick={onToggle} data-stop-action-propagation>
            <AudioStatusIcon playing={playing} icon={icon} color={iconColor} onGetFullUrl={onGetFullUrl} />
        </Root>
    )
}
